function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M15.12 11.004c-1.093 0-2.151-.177-3.138-.497a.869.869 0 00-.898.213L9.69 12.471c-2.516-1.2-4.871-3.467-6.125-6.071l1.734-1.476a.907.907 0 00.213-.906A9.913 9.913 0 015.013.88c0-.48-.4-.88-.88-.88H1.058C.578 0 0 .213 0 .88 0 9.138 6.871 16 15.12 16c.631 0 .88-.56.88-1.049v-3.067c0-.48-.4-.88-.88-.88z",
  id: "phone_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "phone_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#phone_svg__a"
})), React.createElement("use", {
  fill: "#496E9B",
  fillRule: "nonzero",
  xlinkHref: "#phone_svg__a"
}), React.createElement("g", {
  mask: "url(#phone_svg__b)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M-2-2h20v20H-2z"
})));

var Phone = function Phone(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default Phone;